<template>
  <tr>
    <td>{{ title }} ({{ targetUnit.shortLabel || genericLabel }})</td>
    <td v-for="(value, index) in values" :key="index">
      <div class="wrapper">
        <div v-if="value === 'N/A'">N/A</div>
        <ConverterInput
          v-else
          :model-value="value"
          :decimal-places="round ? (value % 1 === 0 ? 0 : 2) : 2"
          :target-unit="targetUnit"
          :base-unit="baseUnit"
          :disableLabel="true"
          :disableSuffix="true"
          mode="read"
        />
      </div>
    </td>
  </tr>
</template>

<script lang="ts" setup>
import type { ConvertableUnit } from "@/libs/units";
import { computed } from "vue";
import ConverterInput from "@/components/ConverterInput.vue";

const props = defineProps<{
  title: string;
  baseUnit: ConvertableUnit;
  targetUnit: ConvertableUnit;
  round?: boolean;
  field: string;
  data: Record<string, number | string>[];
  genericLabel?: string;
  flaggedValues?: (number | string)[];
}>();

const values = computed(() =>
  props.data.map(d => {
    const value = d[props.field];
    if (typeof value === "number" && isNaN(value)) {
      return "N/A";
    }
    return Number(value);
  })
);
</script>

<style scoped lang="scss">
td {
  position: relative;
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    :deep(div) {
      width: 100%;
      height: 100%;
      position: absolute;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
}
</style>
